/**
 * @module kobalte
 * @package @geenius/adapters/solidjs-kobalte
 * @description Shared helpers for the Kobalte variant components. Kobalte is
 * loaded lazily so Node smoke imports can still evaluate the package when the
 * Solid-specific export condition is unavailable.
 */

export type KobalteCore = typeof import("@kobalte/core");

let kobalteCorePromise: Promise<KobalteCore | undefined> | undefined;

export function loadKobalteCore(): Promise<KobalteCore | undefined> {
  kobalteCorePromise ??= import("@kobalte/core").catch(() => undefined);
  return kobalteCorePromise;
}

export function cn(
  ...classes: Array<string | false | null | undefined>
): string | undefined {
  const value = classes.filter(Boolean).join(" ");
  return value.length > 0 ? value : undefined;
}
